import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { PostAdLogParams } from './types';

export const postAdLog = async (events: PostAdLogParams) => {
  return defaultHttpClient.request<void>({
    method: 'POST',
    url: 'api/v2/ad/events',
    data: {
      events,
    },
  });
};
